import { render, staticRenderFns } from "./legendBox2.vue?vue&type=template&id=1b369b12&scoped=true&"
import script from "./legendBox2.vue?vue&type=script&lang=js&"
export * from "./legendBox2.vue?vue&type=script&lang=js&"
import style0 from "./legendBox2.vue?vue&type=style&index=0&id=1b369b12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b369b12",
  null
  
)

export default component.exports